<template>
  <div>
    <div class="content-box-1">
      <div class="grid-container" style="padding-bottom: 60px;">
        <div class="grid-x grid-padding-x">
          <div class="cell small-12">
            <img class="top-tysabri-logo" src="../assets/tysabri_logo_white.png" alt="" />
            <h1 class="app-title">Patient card information</h1>
            <p class="text-center pad-top">
              <img
                @click="scrollDown"
                class="link"
                width="100"
                src="../assets/down_button.png"
                alt="" />
            </p>
            <div class="red-rectangle">
              <img class="link" @click="goToCmi" src="../assets/cmi_button.png" />
              <p class="text-center text-white" style="padding-top: 100px">
                Biogen-291493<br />
                Date of preparation: September 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 100px; background-color: #FFF;">&nbsp;</div>
    <div class="content-box-2">
      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell small-12">
            <p>
              This digital card contains important safety
              information that you need to be aware of
              before, during and after stopping treatment
              with TYSABRI.
            </p>
            <p class="headline pad-top-l pad-bottom-l">
              DO NOT HAVE YOUR TYSABRI TREATMENT IF:
            </p>
            <p class="alert">
              You have an uncommon brain
              infection called progressive multifocal
              leukoencephalopathy (PML)
            </p>
            <p class="alert">
              You have a serious infection or have problems with your immune system
            </p>
            <p class="alert">
              You are currently taking other medications such as interferon or glatiramer acetate
              for treatment of multiple sclerosis (MS)
            </p>
            <p class="alert">
              Show this card to your partner or caregivers. They might see symptoms of PML that you
              might not notice, such as changes in mood or behaviour, memory lapses, speech and
              communication difficulties. You should remain aware of symptoms that might arise for
              up to 6 months after stopping TYSABRI treatment.
            </p>
            <p class="headline pad-top-l pad-bottom-l">
              DURING TREATMENT WITH TYSABRI:
            </p>
            <p>
              There have been reports of an uncommon brain
              infection called PML (progressive multifocal
              leukoencephalopathy) that have occurred
              in patients who have been given TYSABRI.
              PML is a serious condition and can cause
              severe disability or even death.
            </p>
            <p>
              The risk of PML increases with treatment duration, especially beyond 2 years. The risk
              of PML also increases if you have previously taken an immunosuppressant medicine or
              if you have been exposed to John Cunningham Virus (JCV). Your doctor will order blood
              tests to check for JCV.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12">
          <p class="headline pad-top-l">
            SIGNS AND SYMPTOMS OF PML:
          </p>
          <p>
            The symptoms of PML may be similar to those of a MS relapse. Therefore, if you believe
            your MS is getting worse or if you notice any new symptoms while you are on TYSABRI
            treatment or for up to 6 months after stopping TYSABRI treatment, it is very important
            that you speak to your doctor as soon as possible. PML symptoms generally develop more
            slowly than those associated with a MS relapse (over days or weeks), and may be similar
            to your MS symptoms.
          </p>
          <p class="headline-alt">
            Signs
          </p>
          <p class="bullet">
            Changes in mood, mental ability and concentration
          </p>
          <p class="bullet">
            Behavioural changes
          </p>
          <p class="bullet">
            Weakness on one side of the body
          </p>
          <p class="bullet">
            Vision problems
          </p>
          <p class="bullet">
            New neurological symptoms that are unusual
            for you
          </p>
          <p>
            Management of PML requires immediately stopping TYSABRI treatment.
          </p>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12">
          <p class="headline pad-top-l">
            SERIOUS INFECTIONS
          </p>
          <p>
            Other serious infections may occur with TYSABRI. Speak to your doctor as soon as
            possible if you think you have developed a severe, persistent infection, for example a
            persistent fever.
          </p>
          <p class="text-heavy">
            The symptoms of infections include:
          </p>
          <p class="bullet">
            An explained fever
          </p>
          <p class="bullet">
            Shortness of breath
          </p>
          <p class="bullet">
            Stiff neck
          </p>
          <p class="bullet">
            Headache
          </p>
          <p class="bullet">
            Severe diarrhoea
          </p>
          <p class="bullet">
            Prolonged dizziness
          </p>
          <p class="bullet">
            Weight loss
          </p>
          <p class="bullet pad-bottom-l">
            Listlessness
          </p>
        </div>
      </div>
    </div>
    <div class="content-box-3">
      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell small-12">
            <p class="marg-top-xl tick">
              Keep this with you at all times, and 6
              months after the last dose of TYSABRI,
              since side effects may occur even after
              you have stopped treatment with TYSABRI
            </p>
            <p class="tick">
              Show this to any doctor or nurse involved with your treatment, not only your
              neurologist
            </p>
            <p class="tick">
              Read the TYSABRI Consumer Medicine
              Information to ensure that you have the
              most up-to-date information
            </p>
            <p class="tick">
              If you experience any side effects, talk
              to your doctor, pharmacist or nurse. This
              includes any possible side effects not listed
              in the Consumer Medical Information
            </p>
            <p class="text-center pad-top-xxl">
              <img width="400px" src="../assets/tysabri_logo.png" alt="" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <LeaveSite @close="leaveSite = false" v-if="leaveSite" />
  </div>
</template>

<script>
import LeaveSite from './LeaveSite.vue';

export default {
  name: 'Content',
  components: {
    LeaveSite,
  },
  data() {
    return {
      leaveSite: false,
    };
  },
  methods: {
    goToCmi() {
      this.leaveSite = true;
    },
    goToPaq() {
      window.open('https://biogenlinc-assets-bucket.s3.eu-central-1.amazonaws.com/TYS_Pre-administration_Questionnaire_AU_FINAL.pdf', '_blank').focus();
    },
    async handleHardReload(url) {
      await fetch(url, {
        headers: {
          Pragma: 'no-cache',
          Expires: '-1',
          'Cache-Control': 'no-cache',
        },
      });
      window.location.href = url;
      window.location.reload();
    },
    reloadSite() {
      this.handleHardReload(window.location.href);
    },
    scrollDown() {
      const width = document.body.clientWidth;
      if (width === 350) {
        window.scrollTo(0, 980);
      }
      if (width === 600) {
        window.scrollTo(0, 1550);
      }
      if (width === 1000) {
        window.scrollTo(0, 1650);
      }
    },
  },
};
</script>
